import { removeVat } from "./vatConverter";

export const calculateTotalPrice = (
    items: PurchaseItem[],
    discountAmount: number,
    discountPercent: number
): number => {
    if (!items || items.length === 0) return 0;

    const subtotal = items.reduce((sum, current) => {
        return sum + current.amount * current.itemPrice * (1 - current.discountPercent / 100);
    }, 0);

    return subtotal * (1 - discountPercent / 100) - discountAmount;
};

export const calculateTotalPriceExVat = (
    items: PurchaseItem[],
    discountAmount: number,
    discountPercent: number
): number => {
    const totalInclVat = calculateTotalPrice(items, discountAmount, discountPercent);
    return removeVat(totalInclVat);
};